export default "__VITE_ASSET__a63c06ec__"